import { useEffect } from 'react';

import { NEXT_PUBLIC_SITE_URL } from '../../appConfig';

export default function useHandleDormantUser(isInactive: boolean) {
  useEffect(() => {
    if (isInactive) {
      alert('휴면 계정인 회원입니다.');
      window.location.href = NEXT_PUBLIC_SITE_URL || '';
    }
  }, [isInactive]);
}
